import axios from "axios";

export const http = new axios.create({	
    baseURL: "https://teccommerce.com.br/",
    headers: {
        Authorization: 'Basic c3lzcGVkOkBzeXNwZWQ='
    }
});